module.exports = __webpack_public_path__ + "static/img/guo.3b48b204.svg";